import { render, staticRenderFns } from "./OrdersPage.vue?vue&type=template&id=c257eb4e&"
import script from "./OrdersPage.vue?vue&type=script&lang=js&"
export * from "./OrdersPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports